// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q-Wq","footer":"styles_footer__23eZj"};